import React, { ChangeEvent } from 'react';

import { Toggle } from '@rbilabs/components-library/build/components/toggle';
import { useIntl } from 'react-intl';

import { DonationId } from './constants';
import { DonationBox, StyledCheckbox, StyledLink, ToggleWrapper, Wrapper } from './styled';
import { IDonationAtCheckoutProps } from './types';

const DonationAtCheckout: React.FC<IDonationAtCheckoutProps> = ({
  onCheckboxChange,
  onToggleChange,
  selectedDonationId,
  donationOptions,
  donationLink,
}) => {
  const { formatMessage } = useIntl();
  const donationEntityText = formatMessage({ id: DonationId });
  return (
    <Wrapper>
      <StyledCheckbox
        data-testid="donation-at-checkout-checkbox"
        label={
          <>
            {formatMessage(
              { id: 'donateTo' },
              {
                link: !!donationLink ? (
                  <StyledLink data-testid="donation-at-checkout-link" href={donationLink}>
                    {donationEntityText}
                  </StyledLink>
                ) : (
                  <span>{donationEntityText}</span>
                ),
              }
            )}
          </>
        }
        name="checkbox"
        checked={!!selectedDonationId}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onCheckboxChange(e.target.checked)}
      />
      <DonationBox show={!!selectedDonationId}>
        <ToggleWrapper>
          <Toggle
            data-testid="donation-at-checkout-toggle"
            options={donationOptions}
            onChange={onToggleChange}
            value={selectedDonationId}
          />
        </ToggleWrapper>
      </DonationBox>
    </Wrapper>
  );
};

export default DonationAtCheckout;
